window.addEventListener('DOMContentLoaded', function() {
  const links = document.links;
  const linksLength = links.length;
  for (let i = 0; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
});




/* ====================================================
ヘッダー高さに合わせて .section-header の margin-bottom を動的調整
2026-05-25 追加
==================================================== */
(function() {
  'use strict';
  
  function adjustSectionHeaderMargin() {
    var headerWrapper = document.querySelector('.header-wrapper') 
                     || document.querySelector('#header-fixed-color');
    var sectionHeader = document.querySelector('.section-header');
    
    if (!headerWrapper || !sectionHeader) return;
    
    var headerHeight = headerWrapper.offsetHeight;
    sectionHeader.style.marginBottom = headerHeight + 'px';
  }
  
  document.addEventListener('DOMContentLoaded', adjustSectionHeaderMargin);
  window.addEventListener('load', adjustSectionHeaderMargin);
  
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(adjustSectionHeaderMargin, 200);
  });
})();